// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"customerList_searchForm__3r5n2"};